import { render, staticRenderFns } from "./UsageRecord.vue?vue&type=template&id=46636bfe&scoped=true&"
import script from "./UsageRecord.vue?vue&type=script&lang=js&"
export * from "./UsageRecord.vue?vue&type=script&lang=js&"
import style0 from "./UsageRecord.vue?vue&type=style&index=0&id=46636bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46636bfe",
  null
  
)

export default component.exports